import { Area, Subarea, Subsubarea } from '@src/main/modules/common/area/domain/Area';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { useEffect, useState } from 'react';

interface AreaProps {
  areas: Area[] | undefined;
  areaId: string | undefined;
  subareaId: string | undefined;
}

export const useAreas = ({ areas, areaId, subareaId }: AreaProps) => {
  const subarea = areas
    ?.find((areaItem: Area) => areaItem.id === areaId)
    ?.subareas.find((subareaItem: Subarea) => subareaItem.id === subareaId);
  const { dashboards } = useDashboardContext();

  const [subsubareaSelected, setSubsubareaSelected] = useState<Subsubarea | undefined>();

  const subsubareas = (subarea?.subsubareas || [])
    .slice()
    .map((subsubarea) => ({
      ...subsubarea,
      dashboards: getDashboardsOfSubsubarea(subsubarea.id, dashboards),
    }))
    .filter((subsubarea) => subsubarea.dashboards.length > 0);

  useEffect(() => {
    setSubsubareaSelected(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaId, subareaId, dashboards]);

  return {
    areas,
    subarea,
    subsubareas,
    subsubareaSelected,
    setSubsubareaSelected,
  };
};

const getDashboardsOfSubsubarea = (
  subsubareaId: string,
  dashboards: Dashboard[] | undefined,
): Dashboard[] =>
  (dashboards || []).filter((dashboard) => dashboard.area.subsubareaId === subsubareaId);
